<section class="banner small">
    <div class="container">
        <div class="row">
            <div class="ten offset-one">
                <div class="banner-content text-center">
                    <h1>HAVE A QUESTION?<br>WE HAVE ANSWERS.</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="banner-fill subtle banner-img"></div>
</section>
<section class="message-bar">
    <div class="msg-text">STILL HAVE QUESTIONS, <a (click)="goToContactUs()">CONTACT US</a> FOR SUPPORT</div>
</section>
<section class="faqs-container page-section">
                <div class="categories" *ngFor="let cat of faqsCategories">
                    <div class="cat-tab" *ngFor="let item of cat?.fields?.freeupFaqs">
                        <h1 class="cat" [class.active]="item?.fields?.categoryId === activeCategory"
                            (click)="setCategory(item?.fields?.category, item?.fields?.categoryId)">
                            <a>{{item?.fields?.category}}</a></h1>
                    </div>
                </div>
</section>
<section class="questions-part page-section">
        <app-support *ngIf="!!isSupport"></app-support>
        <div class="questions-category" *ngIf="!isSupport">
                <div class="questions" *ngFor="let item of questions | async">
                        <div class="position"  *ngFor="let qst of item?.fields?.questions">
                            <div class="copy-icon-link" (click)="toggleActive(qst?.fields?.questionId,qst?.fields?.answerId, true)"><img src="/assets/icon/Copy icon.svg" class="copy-icon" alt="copy icon"><span class="tool-tip-text" *ngIf="!isCopied">Copy question url</span> <span *ngIf="!!isCopied && qst?.fields?.questionId == questionIdParam" class="tool-tip-text copied">Copied!</span></div> 
                            <app-question-answer question="{{qst?.fields?.questionText}}" [id]="qst?.fields?.questionId"
                                [isActive]="qst?.fields?.questionId == questionIdParam"
                                (click)="toggleActive(qst?.fields?.questionId,qst?.fields?.answerId)">
                                <p (click)="collapsed=true" id="{{qst?.fields?.answerId}}"></p>
                            </app-question-answer>
                        </div>
                </div>
        </div>
</section>